import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SiteContextActions } from '@spartacus/core';
import { map } from 'rxjs/operators';

import { loadLanguagesSuccessAction } from '../actions';

@Injectable()
export class DpGetLanguagesEffect {
  getLanguages$ = createEffect(() =>
    inject(Actions).pipe(
      ofType(SiteContextActions.LOAD_LANGUAGES_SUCCESS),
      map(({ payload }) => loadLanguagesSuccessAction({ payload })),
    ),
  );
}
